import {css} from '@emotion/css';
import {negative} from '@fo/shared/styles/mixins';
import {colours, spacing} from '@fo/shared/styles/variables';

const styles = {
  socialShare: css`
    label: socialShare;
    display: inline-flex;
    flex-direction: row;
    margin-right: ${negative(spacing.XXXS)};
    margin-left: ${negative(spacing.XXXS)};
  `,
  link: css`
    label: socialShare__link;
    display: flex;
    padding: ${spacing.XXXS};
    color: ${colours.font.LIGHT_GRAY};

    &:hover {
      color: ${colours.font.ASSISTIVE};
    }
  `,
};

export default styles;
